import React, { useEffect, useState, useContext } from 'react'
import {
  HttpService,
  Title,
  API,
  Messages,
  toast,
  swal,
  DateFormat,
  Spinner
} from '../../../config/react'
import { Link } from 'react-router-dom'
import UserContext from '../../../config/UserContext'
import DataTable from 'react-data-table-component'
const Section = () => {
  const [SectionList, setSectionList] = useState([])
  const user = useContext(UserContext)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)

  const columns = [
    {
      name: 'Section Name',
      sortable: true,
      sortField: 'section_name',
      selector: (row) => row.section_name
    },
    {
      name: 'Template Name',
      selector: (row) => row.template_name
    },
    {
      name: 'Sub Title',
      selector: (row) => row.subtitle
    },
    {
      name: 'Created Date',
      sortable: true,
      sortField: 'created_at',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>
    },
    {
      name: 'Sort Order',
      selector: (row) => row.sort_order
    },
    {
      name: 'Status',
      selector: (row) => (row.status ? 'Active' : 'Inactive')
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          <Link
            to={'/widgets/section/edit/' + row.id}
            className="text-dark"
            title="Edit"
          >
            <i
              className="fa fa-pencil-square-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
          <Link
            onClick={(e) => DeleteSection(e, row.id)}
            to=""
            className="text-dark"
            title="Delete"
          >
            <i
              className="fa fa-trash-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
        </div>
      )
    }
  ]

  const DefaultFilters = {
    page: 1,
    search: '',
    page_size: 10,
    sort_column: '',
    sort_direction: ''
  }

  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const [totalRows, settotalRows] = useState()

  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
  }

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Name."
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) => setCustomFilters({ ...CustomFilters, search: e.target.value })}
      />
    )
  })
  const handleSort = (e, direction) => {
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
  }
  const GetSectionList = () => {
    const param = {
      page: CustomFilters.page,
      search: CustomFilters.search,
      page_size: CustomFilters.page_size,
      sort_column: CustomFilters.sort_column,
      sort_direction: CustomFilters.sort_direction
    }
    setLoading(true)
    HttpService.postApi(API.GetSectionList, param).then((response) => {
      setLoading(false)
      setSectionList(response.data.result[1])
      settotalRows(response.data.result[0][0].total)
      setForceUpdate(!isForceUpdate)
    })
  }
  const DeleteSection = async (e, id) => {
    e.preventDefault()
    swal(Messages.SwalSectionDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          _id: id,
          _deleted_by: user.id
        }
        setLoading(true)
        HttpService.postApi(API.DeleteSection, param).then((response) => {
          setLoading(false)
          toast.success(Messages.sectiondeleted)
          GetSectionList()
          setForceUpdate(!isForceUpdate)
        })
      }
    })
  }
  useEffect(() => {
    setIsAuth(true)
    document.title = Title.WidgetsSection
    GetSectionList()
  }, [CustomFilters])
  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.WidgetsSection} </h3>
        <div className="btn-group">
          <Link
            to="/widgets/section/add"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            Add Section{' '}
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={SectionList}
                  pagination
                  paginationServer
                  persistTableHead={true}
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  subHeaderComponent={subHeaderComponentMemo}
                  onSort={handleSort}
                  progressPending={loading}
                  progressComponent={<Spinner />}
                  sortServer
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Section
